import { render, staticRenderFns } from "./MicrophoneGuideDialog.vue?vue&type=template&id=8e1ddc3a"
import script from "./MicrophoneGuideDialog.vue?vue&type=script&lang=js"
export * from "./MicrophoneGuideDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e1ddc3a')) {
      api.createRecord('8e1ddc3a', component.options)
    } else {
      api.reload('8e1ddc3a', component.options)
    }
    module.hot.accept("./MicrophoneGuideDialog.vue?vue&type=template&id=8e1ddc3a", function () {
      api.rerender('8e1ddc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/call-dialog/MicrophoneGuideDialog.vue"
export default component.exports